const KEY = 'STICKER';
// [KEY] 하위로 둬야 지급/회수 후 [KEY] 무효화 한 번에 보유자 목록까지 걸린다.
const HOLDER_KEY = 'HOLDER';

export { KEY, HOLDER_KEY };
